<!--  -->
<template>
  <v-btn text v-bind="customAttrs" min-width="48" v-on="$listeners" :to="path">
    <v-icon left v-text="icon"></v-icon>
    <v-badge :value="chip" :color="chipColor" dot>
      <span class="subtitle-2 text-capitalize font-weight-light">{{ text }}</span>
    </v-badge>
    <!-- <v-chip v-if="chip" :color="chipColor" x-small text-color="white">{{ chip[0] }}</v-chip> -->
  </v-btn>
</template>

<script>
export default {
  name: "BaseLinkItem",
  components: {},
  props: {
    text: { type: String, default: "" },
    href: { type: String, default: undefined },
    name: { type: String, default: "" },
    icon: { type: [Boolean, String], default: false },
    chip: { type: String, default: "" },
    to: { type: String, default: undefined }
  },
  data: () => ({
    //
  }),

  computed: {
    chipColor() {
      switch (this.chip) {
        case "new":
          return "success";
        case "updated":
          return "pink";
        case "deprecated":
          return "grey";
        case "help":
          return "warning";
        default:
          return "primary";
      }
    },

    customAttrs() {
      const attrs = {
        ...this.$attrs
      };

      if (this.href) {
        attrs.target = "_blank";
        attrs.rel = "noopener";
        attrs.href = this.href;
      }
      return attrs;
    },

    path() {
      if (!this.to) return this.to;

      return {
        path: `/${this.to}/`
      };
    }
  },

  methods: {},

  mounted() {}
};
</script>

<style lang='scss' scoped>
</style>